import { useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';

import { useAuth } from '@features/auth/hooks/useAuth';
import { useLoginMutation } from '@features/shared/api';
import { SiteLayout } from '@features/shared/ui/SiteLayout/SiteLayout';
import { SiteLogoWidget } from '@features/shared/ui/SiteLogo/SiteLogoWidget';

import { LoginPage } from './LoginPage';

type Props = {
  redirect?: string;
};

export function LoginPageWidget({ redirect }: Props) {
  const navigate = useNavigate();
  const { isAuthenticated, login: externalLogin } = useAuth();
  const login = useLoginMutation();

  const isPending = login.isPending;
  const isSuccess = Boolean(login.data?.success);
  const isError = login.data?.success === false;

  if (isAuthenticated) {
    navigate({
      to: redirect ?? '/club',
      from: '/',
    });
  }

  // редирект после логина
  useEffect(() => {
    if (isSuccess) {
      navigate({
        to: redirect ?? '/club',
        from: '/',
      });
    }
  }, [isSuccess, navigate, redirect]);

  return (
    <SiteLayout siteLogo={<SiteLogoWidget />}>
      <LoginPage
        isPending={isPending}
        isError={isError}
        onSubmit={login.mutate}
        onChessOpenClick={() => externalLogin(redirect)}
      />
    </SiteLayout>
  );
}
